module.exports = __webpack_public_path__ + "static/media/phoenix-report.d945be6c.png";